// Data FOB (fim da produção acordado com o fornecedor) — espelho de backend/lib/fob.js
export const DUE_SOON_DAYS = 7;
const SHIPPED = ['Shipped', 'In Customs', 'Delivered'];
const iso = v => (v ? String(v).slice(0, 10) : null);
export const todayIso = () => new Date().toISOString().slice(0, 10);
export function daysBetween(a, b) {
  const x = new Date(`${a}T12:00:00Z`), y = new Date(`${b}T12:00:00Z`);
  if (Number.isNaN(x.getTime()) || Number.isNaN(y.getTime())) return null;
  return Math.round((y - x) / 86400000);
}

export function fobStatus(q, today = todayIso()) {
  const date = iso(q?.fob_ready_date);
  const original = iso(q?.fob_ready_original) || date;
  const actual = iso(q?.fob_ready_actual);
  const remaining = date ? daysBetween(today, date) : null;
  let status = 'none';
  if (actual || (date && SHIPPED.includes(q?.status))) status = 'done';
  else if (date) status = remaining < 0 ? 'late' : remaining <= DUE_SOON_DAYS ? 'due_soon' : 'on_track';
  return {
    date, original, actual, status,
    slip_days: date && original ? daysBetween(original, date) : null,
    days_remaining: status === 'done' ? null : remaining,
    days_late: status === 'late' ? -remaining : 0,
    finished_delta: actual && date ? daysBetween(date, actual) : null,
  };
}

export const FOB_META = {
  none:     { label: 'Sem data FOB',  color: 'var(--gray-500)', bg: 'var(--gray-100)', icon: '—' },
  on_track: { label: 'No prazo',      color: '#276749', bg: '#F0FFF4', icon: '🏭' },
  due_soon: { label: 'Vence em breve — pedir status', color: '#B7791F', bg: '#FFFAF0', icon: '⏰' },
  late:     { label: 'Atrasado — cobrar fornecedor', color: '#B91C1C', bg: '#FEF2F2', icon: '🔴' },
  done:     { label: 'Pronto FOB',    color: '#2B6CB0', bg: '#EBF4FF', icon: '✅' },
};

// Texto curto do status ("faltam 12 dias", "3 dias de atraso", "pronto")
export function fobShort(f) {
  if (!f || f.status === 'none') return '';
  if (f.status === 'done') return 'pronto';
  if (f.status === 'late') return `${f.days_late} dia${f.days_late === 1 ? '' : 's'} de atraso`;
  if (f.days_remaining === 0) return 'vence hoje';
  return `faltam ${f.days_remaining} dia${f.days_remaining === 1 ? '' : 's'}`;
}
